module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/color/golf-0b6594dd342e1420d8535e1d5ad21e0a.svg";